export const LoginResult = Object.freeze({
    SUCCESS: 'Success',
    REDIRECT_PASSWORD_REMAINDER: 'RedirectPasswordRemainder',
    RESET_PASSWORD: 'ResetPassword',
    REQUIRE_EMAIL_MFA: 'RequireEmailMfa',
    REQUIRE_PHONE_CAPTURE: 'RequirePhoneCapture',
    REQUIRE_SMS_MFA: 'RequireSmsMfa',
    INVALID_PHONE: 'InvalidPhone',
    INCORRECT_MFA_CODE: 'IncorrectMfaCode',
    NO_MFA_CODE: 'NoMfaCode',
    TOO_MANY_MFA_ATTEMPTS: 'TooManyMfaAttempts',
    MFA_UNAVAILABLE: 'MfaUnavailable'
  });

export const OTP_EXPIRY_IN_MINUTES = 10;

export const OTP_RETRY_TIME_IN_MINUTES = 10;

export const LoginError = Object.freeze({
  TOO_MANY_VERIFICATION_ATTEMPTS: 'TooManyVerificationAttempts',
  TOO_MANY_CODE_GENERATION_ATTEMPTS: 'TooManyCodeGenerationAttempts',
  VERIFICATION_SERVER_ERROR: 'VerificationServerError'
});


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/login/constant.js
 **/